module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// ./node_modules/entities/maps/xml.json
// module id = 76
// module chunks = 0